/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2023-01-10 10:08:05
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2023-02-02 14:02:23
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\pushManagement\api\index.js
 */

import request from '@/utils/req.js';


// 商品分页查询
export function goodsPage(params) {
    return request.get('/biz/dsicm-goods/page', params)
}

// 添加商品 
export function goodsAdd(params) {
    return request.post('/biz/dsicm-goods', params)
}

// 编辑商品 /ad/dsicm-goods
export function editGoods(params) {
    return request.put('/biz/dsicm-goods', params)
}

// 商品详情
export function goodsDetails(goodsId) {
    return request.get(`/biz/dsicm-goods/${goodsId}`)
}

// 上下架
export function goodsShelves(params) {
    return request.put('/biz/dsicm-goods/state', params)
}

// 移除商品
export function goodsDelete(goodsId) {
    return request.delete(`/biz/dsicm-goods/${goodsId}`)
}

// 商品使用状态查询
export function goodsUseState(goodsId) {
    return request.get(`/biz/dsicm-goods/use-state/${goodsId}`)
}

// 商品引用列表 /ad/dsicm-goods/landing-page/{goodsId}
export function goodsLandingPage(params) {
    return request.get(`/biz/dsicm-goods/landing-page`, params)
}